var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "label" }),
    _c("div", { staticClass: "cadastrante-header" }, [
      _vm._v(_vm._s(_vm.tipoCadastrante))
    ]),
    _vm.isAssociacaoJuridicamenteConstituida || _vm.isEntidadeRepresentativa
      ? _c(
          "div",
          { key: "associacaoEntidade" },
          [
            _c("app-display", {
              class: _vm.mudouEspeciaisCadastrante.mudouPessoa.mudouCNPJ
                ? "text"
                : "",
              attrs: {
                label: "CNPJ:",
                content: _vm.cadastrantePessoaJuridica.cnpj
              }
            }),
            _c("app-display", {
              class: _vm.mudouEspeciaisCadastrante.mudouPessoa.mudouRazaoSocial
                ? "text"
                : "",
              attrs: {
                label: "Razão Social:",
                content: _vm.cadastrantePessoaJuridica.razaoSocial
              }
            }),
            _c("app-display", {
              class: _vm.mudouEspeciaisCadastrante.mudouPessoa.mudouEmail
                ? "text"
                : "",
              attrs: { label: "E-mail:", content: _vm.cadastrantePessoa.email }
            }),
            _vm.isAssociacaoJuridicamenteConstituida
              ? _c("div", { key: "associacao" })
              : _c(
                  "div",
                  { key: "entidade" },
                  [
                    _c(
                      "el-collapse",
                      {
                        model: {
                          value: _vm.representanteId,
                          callback: function($$v) {
                            _vm.representanteId = $$v
                          },
                          expression: "representanteId"
                        }
                      },
                      _vm._l(_vm.cadastrante.representantes, function(
                        representante
                      ) {
                        return _c(
                          "el-collapse-item",
                          {
                            key: representante.id,
                            attrs: {
                              name: representante.id,
                              title: representante.pessoa.pessoaFisica.nome
                            }
                          },
                          [
                            _c("app-display", {
                              class: _vm.mudouEspeciaisCadastrante.mudouPessoa
                                .mudouCPF
                                ? "text"
                                : "",
                              attrs: {
                                label: "CPF:",
                                content: representante.pessoa.pessoaFisica.cpf
                              }
                            }),
                            _c("app-display", {
                              class: _vm.mudouEspeciaisCadastrante.mudouPessoa
                                .mudouRG
                                ? "text"
                                : "",
                              attrs: {
                                label: "RG:",
                                content: representante.pessoa.pessoaFisica.rg
                              }
                            }),
                            _c("app-display", {
                              class: _vm.mudouEspeciaisCadastrante
                                .mudouRepresentanteLegal
                                .mudouCargoFuncaoRepresentante
                                ? "text"
                                : "",
                              attrs: {
                                label: "Cargo/Função:",
                                content: representante.cargoFuncao
                              }
                            })
                          ],
                          1
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
          ],
          1
        )
      : _vm.isOficioPresidente
      ? _c("div", { key: "oficio" }, [
          _c("p", {
            staticClass: "margin-top",
            domProps: { innerHTML: _vm._s(_vm.cadastrante.despacho) }
          })
        ])
      : _c(
          "div",
          { key: "membros" },
          [
            _c(
              "el-collapse",
              {
                model: {
                  value: _vm.membroId,
                  callback: function($$v) {
                    _vm.membroId = $$v
                  },
                  expression: "membroId"
                }
              },
              _vm._l(_vm.cadastrante.membrosComunidade, function(
                membroComunidade
              ) {
                return _c(
                  "el-collapse-item",
                  {
                    key: membroComunidade.id,
                    attrs: {
                      name: membroComunidade.id,
                      title: membroComunidade.pessoa.pessoaFisica.nome
                    }
                  },
                  [
                    _c("app-display", {
                      class: _vm.mudouEspeciaisCadastrante.mudouMembroComunidade
                        .mudouPessoa.mudouCPF
                        ? "text"
                        : "",
                      attrs: {
                        label: "CPF:",
                        content: membroComunidade.pessoa.pessoaFisica.cpf
                      }
                    }),
                    _c("app-display", {
                      class: _vm.mudouEspeciaisCadastrante.mudouMembroComunidade
                        .mudouPessoa.mudouTelefones
                        ? "text"
                        : "",
                      attrs: {
                        label: "Telefone(s):",
                        content: membroComunidade.pessoa.listaTelefones
                      }
                    }),
                    _c("app-display", {
                      class: _vm.mudouEspeciaisCadastrante.mudouMembroComunidade
                        .mudouPessoa.mudouEmail
                        ? "text"
                        : "",
                      attrs: {
                        label: "E-mail:",
                        content: membroComunidade.pessoa.email
                      }
                    }),
                    _vm.showMembroEndereco
                      ? _c(
                          "el-collapse",
                          { attrs: { value: "0" } },
                          [
                            _c(
                              "el-collapse-item",
                              { attrs: { title: "Endereço", name: "0" } },
                              [
                                _c("informacoes-endereco", {
                                  attrs: {
                                    slot: "body",
                                    endereco: membroComunidade.pessoa.endereco,
                                    mudouEndereco:
                                      _vm.mudouEspeciaisCadastrante
                                        .mudouMembroComunidade.mudouEndereco
                                  },
                                  slot: "body"
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              }),
              1
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-481d8c40", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-481d8c40","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/InformacoesEspeciaisCadastrante.vue
// module id = null
// module chunks = 